import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { map, Observable } from 'rxjs';
import { CpPlansModel } from '../../../helpers/objects/dto/client-portal/plans/cp-plans-model';
import { CpPlansProductModel } from '../../../helpers/objects/dto/client-portal/product/cp-plans-product-model';

@Injectable({
  providedIn: 'root'
})
export class CpPlansService {
  appConfig: EnvironmentModel = new EnvironmentModel();
  proposalApi: string ='';
  constructor(@Inject(APP_CONFIG) appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
    this.proposalApi = this.appConfig.api.replace('/fhcp/', '/adhesion/');
  }

  all(): Observable<CpPlansModel[]> {
    let headers = new HttpHeaders();
    headers = headers.set('X-AppContext', this.appConfig.apiAppContext);
    return this.http.get<any>(this.proposalApi + 'products', { headers }).pipe(map((response) => response.body as CpPlansModel[]));
  }

  getByID(code: string): Observable<CpPlansProductModel> {
    let headers = new HttpHeaders();
    headers = headers.set('X-AppContext', this.appConfig.apiAppContext);
    return this.http.get<any>(this.proposalApi+ 'products/' + code, { headers }).pipe(map((response) => response.body as CpPlansProductModel));
  }
}
